<template>
  <div :style="pureBaseStyle">
    <div :class="getCss('login-box')" :style="styles.base">
      <div :class="getCss('login')" :style="styles.fontStyle" v-if="isLogin">
        <div :class="getCss('userinfo-text-up')">
          你好，
          <template>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX" v-html="userName"></span>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
            <span :class="getCss('userinfo-text')">{{ partitionName }}</span>
            <span :class="getCss('userinfo-text')">{{ roleName }}</span>
          </template>
        </div>
        <div :class="getCss('line-box')" :style="loginLineStyle"></div>
        <div :class="getCss('userinfo-text-down')">
          <template v-if="showRole">
            <a :class="getCss('userinfo-text-button')" @click="handleBindRole">{{ userBindText }}
            </a>
          </template>
          <a v-if="!configurationData.disableRewardRecord" :class="getCss('userinfo-text-button')"
            @click="handleClaimRecord">领奖记录</a>
          <a v-if="!configurationData.disableRechargeRecord" :class="getCss('userinfo-text-button')"
            @click="handleRechargeRecord">充值记录</a>
          <!--<br v-if="configurationData.showBindQQ &&
             configurationData.showBindPhone && configurationData.showAccessMakeAppShortCut">-->
          <a v-if="configurationData.showBindQQ" :class="getCss('userinfo-text-button')" @click="showBindQQFunc">{{
            bindBtnText }}</a>
          <a v-if="configurationData.showBindClub" :class="getCss('userinfo-text-button')"
            @click="showBindClubFunc">绑定俱乐部</a>
          <a v-if="configurationData.showBindPhone" :class="getCss('userinfo-text-button')"
            @click="showBindPhoneFunc">绑定手机</a>
          <a v-if="configurationData.showAccessMakeAppShortCut" :class="getCss('userinfo-text-button')"
            @click="showAccessMakeAppShortCutFunc">添加快捷方式</a>
          <a :class="getCss('userinfo-text-button')" v-if="!configurationData.disableChangeLogin"
            @click="change">切换登录方式</a>
          <a :class="getCss('userinfo-text-button')" v-if="showLogout" @click="handleLogout">注销</a>
        </div>
      </div>
      <div :class="getCss('not-login')" v-else :style="styles.fontStyle">
        <span>
          <a @click="showLogin">HI~，请登录</a>
        </span>
      </div>
    </div>
    <div :style="loginDialogStyle">
      <!-- 登录弹窗start -->
      <div :class="getCss('login-tc')" v-show="isShowLogin">
        <div :class="getCss('login-tc-zz')"></div>

        <div :class="getCss('login-div')">
          <div :class="getCss('login-tc-text-body')">
            <p :class="getCss('login-title')">{{ loginTitle }}</p>
            <div :class="getCss('login-body')">
              <div :class="getCss('login-item-wx')">
                <div :class="getCss('login-wx')" @click="wxLogin" :style="imposeLogin === 2 ? disableLogin : ''">
                  <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginWx.png" :class="getCss('login-img-wx')"
                    alt="" />
                </div>
                <div :class="getCss('login-wx-text')" :style="imposeLogin === 2 ? disableLogin : ''">
                  <p :class="getCss('login-btn-text-p')">微信登录</p>
                </div>
                <p :class="getCss('login-now-text')" v-show="loginType === 'wx' && isLogin">（当前）</p>
              </div>
              <!--<div :class="getCss('login-body-kb')"></div>-->
              <div :class="getCss('login-item-qq')">
                <div :class="getCss('login-qq')" @click="qqLogin" :style="imposeLogin === 1 ? disableLogin : ''">
                  <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginQq.png" :class="getCss('login-img-qq')"
                    alt="" />
                </div>
                <div :class="getCss('login-qq-text')" :style="imposeLogin === 1 ? disableLogin : ''">
                  <p :class="getCss('login-btn-text-p')">QQ登录</p>
                </div>
                <p :class="getCss('login-now-text')" v-show="loginType === 'qc' && isLogin">（当前）</p>
              </div>
            </div>
          </div>
          <div :class="getCss('login-tc-close-div')">
            <span :class="getCss('login-tc-close')" @click="closeLogin">
              <img src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/close.png" alt="">
            </span>
          </div>
        </div>
      </div>
      <!-- 登录弹窗end -->
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
export default {
  name: 'CTgclubUserAreaFlatten',
  components: {
  },
  filters: {
    base64decode(value) {
      return common.tool.Base64.decode(value);
    },
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      cssPrefix: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? 'tgclub-user-area-flatten-h5-' : 'tgclub-user-area-flatten-pc-',
      isShowLogin: false,
      scrollYTop: 0,
      loginTitle: '请登录账号',
      loginType: '',
      isShowInfo: false,
      imposeLogin: 0, // 限制参与 0不限，1仅限微信，2仅限QQ
      gameCode: '',
      showBindRoleTag: false,
      loginChangeStatus: '', // 与$store.state.isLogin区别在于初始值不同
    };
  },
  computed: {
    // 端游判断
    isClientGame() {
      // 端游需要开启微信登录
      /* if (!!this.configurationData.needWXLogin) {
        return false;
      }*/
      return this.$actInfo && this.$actInfo.game_type === 1;
    },
    loginDialogStyle() {
      return {
        zIndex: 100,
      };
    },
    pureBaseStyle() {
      return {
        left: this.styles.base.left,
        top: this.styles.base.top,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    loginLineStyle() {
      const width1 = this?.styles?.loginLineStyle?.width || (this.isMobile ? '5.98rem' : '598px');
      const color = this?.styles?.loginLineStyle?.backgroundColor || '#FFFFFF';
      return {
        // ...loginLine,
        width: width1,
        border: this.isMobile ? `0.01rem solid ${color}` : `1px solid ${color}`,
      };
    },
    bindBtnText() {
      return this.configurationData.bind_btn_text || '绑定QQ';
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    },
    showLogout() {
      const isShanxianApp = /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
      const isBbApp = !!window.navigator.userAgent.match(/gamehelper/i);
      if (isShanxianApp || isBbApp) {
        return false;
      }
      return this.$actInfo && !this.$ast.isAPP();
    },
    disableLogin() {
      return {
        opacity: .2,
        cursor: 'no-drop',
      };
    },

    showRole() {
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        return this.isRoleStatusValid;
      }
      return this?.actInfo?.extendConfig?.forceRole;
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    userAvatar() {
      return this.isLogin ? this.userInfo.avatar : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
  },
  watch: {
    // 监听状态变化,未登录和登录的情况,自动弹出登录窗口处理
    loginChangeStatus: {
      async handler(newVal) {
        if (this.$isInEditor) return;
        console.log('watch  loginChangeStatus', newVal);
        await this.doSleep(2000); // 刚进入页面this.isLogin都是false,延时读取
        await this.handleLoginPop();
      },
    },
  },
  async mounted() {
    console.log('【tgclub-user-area-flatten】configurationData=', this.configurationData);
    document.addEventListener('click', (e) => {
      if (this.$el && !this.$el.contains(e.target)) {
        this.isShowInfo = false; // 点击其他区域关闭
      }
    });
    await this.initialize();
    if (this.$isInEditor && !this.isInPreview) return;
    if (!this.isLogin && !this.$ast.isAPP()) {
      this.reportExposeFunc('login_expose', { type: 'flatten_nologin' });
    }
    this.$eventBus.$on('ceiba:custom:events:pull-user-area-login', () => {
      this.isShowLogin = true;
    });
    this.$eventBus.$on('ceiba:common:events:bind-role', () => {
      this.reportReturnGameFlow(this.roleInfo);
    });
  },
  methods: {
    async initialize() {
      if (this.$isInEditor && !this.isInPreview) return;
      // 用户登陆
      this.checkShowLogin();
      this.$eventBus.$onLogined(this.imposeLoginTips);
      this.gameCode = this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code;
      this.loginChangeStatus = this.isLogin;
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async handleLoginPop() {
      const { isActionShowLoginDialog } = this.configurationData;
      if (!this.$ast.isAPP()) {
        if (!this.isLogin) {
          if (isActionShowLoginDialog) {
            this.showLogin();
          }
        } else {
          this.closeLogin();
        }
      }
    },
    showLogin() {
      if (this.$isInEditor && !this.isInPreview) return;
      this.loginTitle = '请登录账号';
      this.isShowLogin = true;
      this.fixedBody();
      this.reportExposeFunc('show_pop', { pop_name: 'login_pop' });
      if (!this.$ast.isAPP()) {
        this.reportFunc('login_click', { type: 'flatten_nologin' });
      }
    },
    closeLogin() {
      this.isShowLogin = false;
      this.removeFixedBody();
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'close' });
    },
    fixedBody() {
      const bodyEl = document.body;
      let top = 0;
      top = window.scrollY;
      this.scrollYTop = top;
      if (this.isMobile) {
        bodyEl.style.position = 'fixed';
        bodyEl.style.top = `${-top}px`;
      }
    },
    removeFixedBody() {
      const bodyEl = document.body;
      bodyEl.style.position = '';
      bodyEl.style.top = '';
      window.scrollTo(0, this.scrollYTop); // 回到原先的top
    },
    change() {
      if (this.$ast.isAPP()) {
        // window.Tgclub?.showLoginWithScheme(window.location.href);
        window.UPBridge?.showLoginWithSchema({ schema: window.location.href });
      } else {
        this.loginTitle = '切换登录方式';
        this.isShowInfo = false;
        this.isShowLogin = true;
        this.fixedBody();
      }
      this.reportFunc('login_click', { type: 'flatten_change' });
    },
    wxLogin() {
      if (this.imposeLogin === 2) {
        return;
      }
      this.login({
        loginType: 'wx',
      });
      this.handleClickEvent();
      console.log('【tgclub-user-area-flatten】wxLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'wx' });
    },
    qqLogin() {
      if (this.imposeLogin === 1) {
        return;
      }
      this.login({
        loginType: 'qq',
      });
      this.handleClickEvent();
      console.log('【tgclub-user-area-flatten】qqLogin');
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'qq' });
    },
    async handleLogout() {
      this.logout();
    },
    checkShowLogin() {
      if (this.$platform.isWX || this.$platform.isSafari) {
        this.imposeLogin = this.configurationData.imposeLogin;
      } else {
        this.imposeLogin = 2;
      }
      if (this.isClientGame) {
        if (!!this.configurationData.needWXLogin) {
          this.imposeLogin = 0;
        } else {
          this.imposeLogin = 2;
        }
      }
    },
    imposeLoginTips() {
      if (this.isLogin) {
        this.loginChangeStatus = this.isLogin;
        this.loginType = this.userInfo.acctype;
        try {
          const urlHost = window?.CEIBA_API_HOST?.replace(/agw/g, 'bgw') || 'https://bgw-t.xinyue.qq.com';
          const url = `${urlHost}/XySrv.UserSrv/GetUserInfo`;
          this.$requestInstance.post(url, {});
        } catch (err) {
          console.error('【tgclub-user-area-flatten】GetUserInfo fail catch error =', err);
        }
      }
      if ((this.configurationData.imposeLogin === 2 && this.loginType === 'wx')
        || (this.configurationData.imposeLogin === 1 && this.loginType === 'qc')) {
        if (this.loginType === 'wx') {
          this.confirmMsg('当前活动仅限QQ用户参与', '切换为QQ登录');
        } else {
          this.confirmMsg('当前活动仅限微信用户参与', '切换为微信登录');
        }
        this.reportExposeFunc('show_pop', { pop_name: 'login_impose' });
      } else {
        this.handleLogin();
      }
    },
    confirmMsg(tipMsg, confirmMsg) {
      const that = this;
      this.$confirm({
        msg: tipMsg,
        confirmText: confirmMsg,
        cancel() {
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'cancel' });
        },
        confirm() {
          if (that.$ast.isAPP()) {
            // window.Tgclub?.showLoginWithScheme(window.location.href);
            window.UPBridge?.showLoginWithSchema({ schema: window.location.href });
            return;
          }
          that.change();
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'switch' });
        },
      });
    },
    async handleLogin() {
      // this.checkShowLogin();
      // 自动绑定角色
      const buShanDang = this.actInfo.extendConfig?.bushandang || false;
      if (buShanDang) {
        if (this.isRoleStatusValid) {
          await this.checkRoleInfo();
        }
      } else {
        if (this?.actInfo?.extendConfig?.forceRole) {
          await this.checkRoleInfo();
        }
      }
      this.reportExposeFunc('login_expose', { type: 'flatten_login' });
      const { isUserReported = false } = this.configurationData;
      // 只需要 微信端上报
      if (isUserReported && this.isWX) {
        const res = await this.$axiosInstance.get('https://wang.xinyue.qq.com/api/headurl/update');
        console.log(res, '登录态头像上报res');
      }
    },
    async handleBindRole() {
      try {
        if (this.showBindRoleTag === true) {
          return;
        }
        this.showBindRoleTag = true;
        const that = this;
        setTimeout(() => {
          that.showBindRoleTag = false;
        }, 1500);
        console.log('【tgclub-user-area-flatten】user access click handleBindRole');
        this.reportFunc('login_click', { type: 'flatten_role' });
        baseComponents.gameRoleSelect.showGameRoleSelect(this.currentGameCode || this.actInfo.game_code, {})
          .then((roleInfo) => {
            console.log('【tgclub-user-area-flatten】select role=', roleInfo);
            this.saveCurrentRole({
              isRoleReady: true,
              roleInfo,
            });
            this.reportReturnGameFlow(roleInfo);
          })
          .catch((response) => {
            console.error('action bind role fail  response =', response);
          });
      } catch (err) {
        console.error('action bind role fail catch  error =', err);
      }
    },
    // 上报回流
    reportReturnGameFlow(roleInfo) {
      const { reportReturnGameFlowId = 0 } = this.configurationData;
      if (reportReturnGameFlowId > 0 && roleInfo) {
        console.log('access report after report  role=', roleInfo, reportReturnGameFlowId);
        this.flowRequest({
          flowId: reportReturnGameFlowId,
          params: {
            role: roleInfo,
          },
        }).then(res => console.log('用户回流上报流程reportReturnGameFlowId =', reportReturnGameFlowId, '请求返回 = ', res));
      }
    },
    showBindPhoneFunc() {
      this.isShowInfo = false;
      this.$eventBus.$emit('ceiba:custom:events:call:use:bind:phone:pop', {});
    },
    showBindQQFunc() {
      this.isShowInfo = false;
      this.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill', {});
    },
    // 拉起绑定俱乐部弹窗
    showBindClubFunc() {
      this.$eventBus.$emit('ceiba:common:events:club-fill', {});
    },
    // 快捷方式
    showAccessMakeAppShortCutFunc() {
      this.$eventBus.$emit('ceiba:custom:events:call:use:add:shortcut', {});
    },
    async handleClaimRecord() {
      this.reportFunc('login_click', { type: 'flatten_gift' });
      this.isShowInfo = false;
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      await baseComponents.pacakgeClaimRecords.showPackageClaimRecords(this.gameCode, {
        hidePackageIds: (this.configurationData.hidePackageIds || '').split(','),
        params: {
          activity_id: this.actInfo.activity_id.toString(),
          business_id: this.actInfo.ast,
          resource_id: this.configurationData?.resource_id ? `${this.configurationData.resource_id}` : '',
          flow_version: this.actInfo.flow ? parseInt(this.actInfo.flow, 10) : 1,
          moduleId: this.configurationData?.moduleId ? `${this.configurationData.moduleId}` : '',
          category: this.configurationData?.category ? `${this.configurationData.category}` : '',
          iExcludePackageId: this.configurationData?.iExcludePackageId ? `${this.configurationData.iExcludePackageId}` : '',
          scene: this.configurationData?.scene ? `${this.configurationData.scene}` : 'ceiba_act',
        },
        pageSize,
        option: {
          header: false,
          footer: false,
          height: this.isMobile ? '3.6rem' : 'auto',
          width: this.isMobile ? '7.2rem' : '500px',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
    async handleRechargeRecord() {
      this.isShowInfo = false;
      if (!this.roleInfo.role_id && this.showRole) {
        this.$alert({ msg: '请先绑定角色' });
        return false;
      }
      const myRoleInfo = this.roleInfo;
      await baseComponents.rechargeRecord.showRechargeRecord({
        thisFlowRequest: this.flowRequest,
        myRoleInfo,
        payBusiness: this.configurationData.payBusiness,
        sellChannel: this.configurationData.sellChannel,
        flowId: this.configurationData.rechargeRecordFlowId,
        spInfo: '',
        pageSize: 6,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.rechargeRecordFontColor || '#c20303',
              backgroundImage: `url(${this.configurationData.rechargeRecordBackgroundImage})`,
            },
          ),
        },
      });
    },
    reportFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
      }
    },
    reportExposeFunc(key, obj) {
      if (this.$isInEditor && !this.isInPreview) return;
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventType: 1001,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
